import Body from './Body';
import Header from './Header';

const Typography = {
  Body,
  Header,
};

export default Typography;
